import Layout from "../../components/Layout";
import SearchBox from "../../components/SearchBox";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFilter} from "@fortawesome/free-solid-svg-icons";
import {Link, useNavigate} from "react-router-dom";
import Pagination from "../../components/Pagination";
import PagesTable from "../../components/Tables/PagesTable";
import {useEffect, useState} from "react";
import FilterBox from "../../components/FilterBox";
import ApiRoute, {shopId} from "../../helper/api";
import Buttons from "react-multi-date-picker/components/button";
import CreatePriceListModal from "../../components/PriceList/CreatePriceListModal";
import CreatePageModal from "../../components/Page/CreatePageModal";
import ShopSelect from "../../components/Shop/ShopSelect";

function Pages() {

    const navigate = useNavigate()
    const [createModal, setCreateModal] = useState(false)
    const [shop_id, setShopId] = useState('')

    const [isLoading, setIsLoading] = useState(true)
    const [updateData, setUpdateData] = useState('0')
    const [pageNumber, setPageNumber] = useState(1)
    const [data, setData] = useState({})
    const [searchQuery, setSearchQuery] = useState({
        term: '',
        by: 'title'
    })
    const [filterQuery, setFilterQuery] = useState({})

    // state tab for filtering
    const [statsTab , setStatsTab] = useState(null)
    const [selectedStatsTab , setSelectedStatsTab] = useState('')

    //fetch data from server and update data /| based on updateData state
    useEffect(() => {
        (async () => {
            setIsLoading(true)
            const  res  = await ApiRoute.page.index.fn({
                shop_id: shop_id,
                page : pageNumber
            },filterQuery)
            setData(res)
            setIsLoading(false)
        })();
    }, [updateData]);

    const paginationData = data?.results
    const tableData = data?.results?.data ?? []

    // watch pageNumber and update updateData state
    useEffect(() => {
        setUpdateData(Date.now().toString())
    }, [pageNumber]);
    // watch searchQuery and update updateData state
    useEffect(() => {
        filterQuery.quick_search = searchQuery
        setUpdateData(Date.now().toString())
    }, [searchQuery]);

    return (
        <Layout>
            <div>
                <div className="flex items-center justify-between mb-3">
                    <div className="page-title flex-auto ml-3 md:ml-0">
                        <span className="inline-block bg-white pl-3">صفحات</span>
                    </div>
                    <button onClick={() => setCreateModal(true)} className="btn-blue text-center md:hidden"> افزودن صفحه جدید</button>
                </div>

                <div className="grid md:flex justify-between items-center gap-3">
                    <div className="flex gap-3">
                        <SearchBox SetSearchQuery={setSearchQuery} SearchIn={false}/>
                    </div>
                    <button onClick={() => setCreateModal(true)} className="btn-blue text-center hidden md:block">افزودن صفحه جدید</button>
                </div>

                <div className="my-3">
                    <ShopSelect
                        hasFrontEnd={true}
                        assignItem={(shop) => {
                            setShopId(shop?._id)
                            setUpdateData(Date.now().toString())
                        }}
                        multiple={false}
                        defaultValue={shop_id}
                    />
                </div>


                <div className="main-content p-1 mt-3">
                    {data && <PagesTable tableData={tableData}/>}
                    {data && <Pagination Data={paginationData} SetPageNumber={setPageNumber}/>}
                </div>
            </div>

            {createModal && <CreatePageModal
                closeModal={ () => {
                    setCreateModal(false);
                } } event={ (res) => {
                setUpdateData(Date.now().toString())
                return navigate("/pages/edit?id="+res.results._id)
            } }/>}


        </Layout>
    )
}

export default Pages